export default {"src":"/_next/static/media/clever.acf0ef55.svg","height":27,"width":24,"blurWidth":0,"blurHeight":0};